var React = require('react');

function Success (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"icoSuccess"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("g",{"id":"icoSuccess","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":2},React.createElement("path",{"d":"M6.1875,9.765625 L12.046875,3.90625 L11.125,2.953125 L6.1875,7.90625 L3.875,5.578125 L2.953125,6.5 L6.1875,9.765625 Z M7.5,0 C8.68750594,0 9.78645328,0.296872031 10.796875,0.890625 C11.7760466,1.45312781 12.5468722,2.22395344 13.109375,3.203125 C13.703128,4.21354672 14,5.31249406 14,6.5 C14,7.68750594 13.703128,8.78645328 13.109375,9.796875 C12.5468722,10.7760466 11.7760466,11.5468722 10.796875,12.109375 C9.78645328,12.703128 8.68750594,13 7.5,13 C6.31249406,13 5.21354672,12.703128 4.203125,12.109375 C3.22395344,11.5364555 2.45312781,10.7604216 1.890625,9.78125 C1.29687203,8.77082828 1,7.67708922 1,6.5 C1,5.32291078 1.29687203,4.22917172 1.890625,3.21875 C2.46354453,2.23957844 3.23957844,1.46354453 4.21875,0.890625 C5.22917172,0.296872031 6.32291078,0 7.5,0 Z","id":"check_circle---material","fill":"#67DF9B"}))]);
}

Success.defaultProps = {"width":"15px","height":"13px","viewBox":"0 0 15 13","version":"1.1"};

module.exports = Success;

Success.default = Success;



//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-react-loader/lib/loader.js!./src/icons/success.svg
// module id = 329
// module chunks = 0